<script setup lang="ts">
import { ref } from 'vue';
import { useGameStore } from '../stores/game';

const store = useGameStore();
const pin = ref('');
const error = ref('');

defineEmits<{ (e: 'close'): void; (e: 'unlock'): void }>();

function press(d: string) {
  if (pin.value.length < 4) {
    pin.value += d;
    error.value = '';
  }
}
function del() {
  pin.value = pin.value.slice(0, -1);
}
function submit(emit: (ev: 'unlock') => void) {
  const expected = store.config?.event.in_game_pin ?? '1234';
  if (pin.value === expected) {
    pin.value = '';
    emit('unlock');
  } else {
    error.value = 'Incorrect PIN';
    pin.value = '';
  }
}
</script>

<template>
  <div class="pin-bg" @click="$emit('close')"></div>
  <div class="pin-card">
    <div class="title">Admin Access</div>
    <div class="dots">
      <div v-for="i in 4" :key="i" class="dot" :class="{ filled: pin.length >= i }"></div>
    </div>
    <div class="pad">
      <button v-for="n in [1, 2, 3, 4, 5, 6, 7, 8, 9]" :key="n" class="key" @click="press(String(n))">{{ n }}</button>
      <button class="key del" @click="del">⌫</button>
      <button class="key" @click="press('0')">0</button>
      <button class="key ok" @click="submit($emit)">OK</button>
    </div>
    <div class="err">{{ error }}</div>
  </div>
</template>

<style scoped>
.pin-bg {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.7);
  z-index: 1000;
}
.pin-card {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: var(--dark2);
  border: 1px solid var(--or-dk);
  border-radius: var(--r);
  padding: 28px 24px;
  width: 90%;
  max-width: 320px;
  z-index: 1001;
  box-shadow: var(--sh);
}
.title {
  text-align: center;
  font-weight: 700;
  font-size: 14px;
  text-transform: uppercase;
  letter-spacing: 2px;
  margin-bottom: 18px;
}
.dots {
  display: flex;
  justify-content: center;
  gap: 14px;
  margin-bottom: 22px;
}
.dot {
  width: 15px;
  height: 15px;
  border-radius: 50%;
  border: 2px solid var(--or-dk);
}
.dot.filled {
  background: var(--or);
  border-color: var(--or);
}
.pad {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;
}
.key {
  background: var(--dark3);
  border: 1px solid var(--surf3);
  border-radius: 10px;
  color: var(--white);
  font-size: 22px;
  font-weight: 600;
  padding: 15px;
  cursor: pointer;
}
.key:active {
  background: var(--or-dk);
  transform: scale(0.95);
}
.key.del {
  font-size: 15px;
  color: var(--grey);
}
.key.ok {
  background: var(--or);
  font-size: 13px;
  font-weight: 900;
  letter-spacing: 1px;
}
.err {
  color: var(--red);
  font-size: 13px;
  margin-top: 12px;
  min-height: 18px;
  text-align: center;
}
</style>
